module.exports = __webpack_public_path__ + "static/media/timeline_mrh.653d8810.svg";